module.exports = __webpack_public_path__ + "static/ricoh360-tours-98f138cf2ad357fdc937e6920aa98d40.png";